<template>
    <div class="custom-tooltip">
        <img class="tooltip-icon" @mouseover="mouseoverHandler" @mouseleave="mouseleaveHandler"
            @mousemove="mousemoveHandler" :src="require('@/assets/images/question.png')">
        <div  class="tooltip-container" :style="{ left: mouseX + 'px' }" ref="tooltipContainer">
            <div class="tooltip-header" v-if="$slots.header">
                <slot name="header"></slot>
            </div>
            <div class="tooltip-content" v-if="$slots.content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ChatterTooltip",
    data() {
        return {
            isHovered: false,
            mouseX: 0,
            mouseY: 0,
            tooltipWidth: 0,
        }
    },
    methods: {
        mouseoverHandler() {
            this.isHovered = true;
            this.$nextTick(() => {
                this.tooltipWidth = this.$refs.tooltipContainer.offsetWidth;
            })

        },
        mouseleaveHandler() {
            this.isHovered = false;
            this.mouseX = 0;
            this.mouseY = 0;
        },
        mousemoveHandler(event) {
            const defaultOffset = 30;
            // 마우스 위치와 툴팁 넓이의 합이
            // 클라이언트 뷰포트 - 마우스 위치보다 크다면 
            // 툴팁을 왼쪽으로 이동

            // 마우스 위치 X
            const clientX = event.clientX;
            // 마우스 위치 Y
            const clientY = event.clientY;
            if (clientX + this.tooltipWidth + defaultOffset >= this.viewportWidth) {
                this.mouseX = -1 * (defaultOffset + this.tooltipWidth);
            } else {
                this.mouseX = defaultOffset;
            }

            this.mouseY = clientY - 5;
        },

    },
    computed: {
        viewportWidth() {
            return window.innerWidth;
        }
    }
}

</script>
<style scoped>
.custom-tooltip {
    position: relative;
    display: inline-block;
}

.custom-tooltip .tooltip-icon {
    width: 100%;
}

.custom-tooltip .tooltip-container {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: all 0.2s;
    /* left: 0%; */
    margin-left: 2rem;
    /* min-width: 330px; */
    line-break: auto;
    font-family: 'NanumGothic';
    border-radius: 5px;
    background-color: rgb(246, 246, 250);
    box-shadow: 0px 0px 3px grey;
    z-index: 40;
    border: none;
    font-weight: normal;
    overflow: hidden;
}

.custom-tooltip .tooltip-container div {
    padding: 0.8em;
}

.custom-tooltip .tooltip-container .tooltip-header {
    display: block;
    font-weight: bold;
    /* color: rgb(255, 230, 0); */
    color: white;
    background-color: rgb(46, 46, 56);
    /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
}

.custom-tooltip .tooltip-container .tooltip-content {
    background-color: white;
    color: black;
    width: max-content;
    /* text-wrap: nowrap; */
}

.custom-tooltip .tooltip-icon:hover~.tooltip-container {
    visibility: visible;
    opacity: 1;
}
</style>